import moment from "moment";

export function armaMailFactAprobada(factibilidad, cliente, datosFactAprobar, direccionentrega, artefactos, calculos, precios) {

    const mail = `<!DOCTYPE html>
      <html lang="es">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Detalle de Factibilidad</title>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  line-height: 1.6;
                  margin: 20px;
                  color: #333;
              }
              .container {
                  border: 1px solid #ccc;
                  padding: 20px;
                  border-radius: 8px;
                  max-width: 600px;
                  margin: 0 auto;
                  background-color: #f9f9f9;
              }
              h2 {
                  color: #4CAF50;
              }
              hr {
                  border: 0;
                  border-top: 1px solid #ccc;
                  margin: 20px 0;
              }
              .section-title {
                  font-size: 1.2em;
                  margin-bottom: 10px;
                  padding: 10px;
                  background-color: #4CAF50;
                  color: white;
                  border-radius: 4px;
              }
              .label {
                  font-weight: bold;
              }
              .artefacto {
                  padding-bottom: 10px;
                  margin-bottom: 10px;
              }
          </style>
      </head>
      <body>
          <div class="container">
              <!-- Encabezado -->
              <h2>La factibilidad ${factibilidad.id} ha sido aprobada.</h2>
              <hr>      
              ${factibilidad.id_tipofact === 235 ? (`
                <!-- Datos de Facturación del Cliente -->
                <div>
                  <div class="section-title">Información de facturación:</div>
                  <ul>
                  <li><span class="label">EMPRESA:</span> ${cliente.empresa || "No registrado"}</li>
                  <li><span class="label">Cliente:</span> ${cliente.razon_social}</li>
                  <li><span class="label">Dirección Fiscal:</span> ${cliente.direccion_fiscal}, ${cliente.localidad}, ${cliente.provincia}</li>
                  <li><span class="label">Localidad:</span> ${cliente.localidad}</li>
                  <li><span class="label">Provincia:</span> ${cliente.provincia}</li>
                  <li><span class="label">Mails:</span> ${cliente.mails}</li>
                  <li><span class="label">Teléfono/s:</span> ${cliente.telefono1 || ""} ${cliente.telefono2 || ""}  ${cliente.telefono3 || ""} </li>
                  <li><span class="label">Situación Iva:</span> ${cliente.sit_iva}</li>
                  <li><span class="label">Condición de pago:</span> ${cliente.condicion}</li>
                  <li><span class="label">Cuit/DNI:</span> ${cliente.cuit || "No registrado"}</li>
                  <li><span class="label">Segmento:</span> ${cliente.segmento}</li>      
                  </ul>
              </div>
              <hr>
              <div>
                ${precios ? (`
                <div class="section-title">Precios Vigentes Del Segmento (${moment(precios.vigencia).format("DD-MM-YYYY")} - ${precios?.fin_vigencia ? moment(precios.fin_vigencia).format("DD-MM-YYYY") : "Actualidad"}):</div>
                <p><span class="label"><u>PRECIO POR LITRO:</u></span></p>
                <ul>
                  <li>LT SIN IVA: $ ${precios.precio_litro_sin_iva}</li>
                </ul>
                <p><span class="label"><u>PRECIO POR KILOGRAMO:</u></span></p>
                <ul>
                  <li>KG SIN IVA: $ ${precios.precio_kilo_sin_iva}</li>
                </ul>
                `) :
                (`Precios de segmento NO DISPONIBLES.`)}
                
              </div>
              <hr>
                `) : (`
                <p><span class="label">Cliente:</span> ${cliente.razon_social} (${cliente.sisven_id || "Sisven ID no registrado"}) </p>
                <p><span class="label">Cuit/DNI:</span> ${cliente.cuit}</p>
                `)
        }
              <!-- Datos de Dirección de Entrega -->
              <div>
                  <div class="section-title">Dirección de entrega:</div>
                <ul>
                  <li><span class="label">Contacto:</span> ${direccionentrega.contacto || "No registrado"}</li>
                  <li><span class="label">Dirección de entrega:</span> ${direccionentrega.direccion_entrega}</li>
                  <li><span class="label">Localidad:</span> ${direccionentrega.localidad}</li>
                  <li><span class="label">Provincia:</span> ${direccionentrega.provincia}</li>
                  <li><span class="label">Teléfono/s:</span> ${direccionentrega.telefono1 || ""} ${direccionentrega.telefono2 || ""}  ${direccionentrega.telefono3 || ""} </li>
                  <li><span class="label">Mails:</span> ${direccionentrega.mails || "No registrado"}</li>
                  <li><span class="label">Latitud:</span> ${direccionentrega.latitud}</li>
                  <li><span class="label">Longitud:</span> ${direccionentrega.latitud}</li>
                </ul> 
              </div>
              <hr>
              <!-- Información de la Instalación -->
              <div>
                  <div class="section-title">Información de la instalación:</div>
                  ${!!calculos.kganual ? (
            ` <p><span class="label">Consumo anual estimado:</span> ${calculos.kganual} KGS </p>
                    <hr>`
        ) : (
            ` <p><span class="label">Consumo anual estimado:</span> "No disponible, chequear en factibilidad."</p>
                    <hr>`
        )
        }
                 
      
                  <!-- Artefactos a Abastecer -->
                  <div>
                      <p><span class="label">Artefactos a abastecer:</span></p>
                      <ul>
                          ${artefactos && artefactos.map(artefacto => `
                              <li>
                                  <span class="label">${artefacto.artefacto}</span> (${artefacto.consumoanual} KG anuales)
                              </li>
                          `).join('')}
                      </ul>
                  </div>
                  <hr>
      
                  <!-- Tanques a Instalar -->
                  <div>
                      <p><span class="label">Tanques a instalar:</span></p>
                      <ul>
                          <li><span class="label">Tanques 0.5 m3:</span> ${factibilidad.canttk_05 || "Ninguno"}</li>
                          <li><span class="label">Tanques 1 m3:</span> ${factibilidad.canttk_1 || "Ninguno"}</li>
                          <li><span class="label">Tanques 2 m3:</span> ${factibilidad.canttk_2 || "Ninguno"}</li>
                          <li><span class="label">Tanques 4 m3:</span> ${factibilidad.canttk_4 || "Ninguno"}</li>
                          <li><span class="label">Tanques 7 m3:</span> ${factibilidad.canttk_7 || "Ninguno"}</li>
                      </ul>
                  </div>
              </div>
              <hr>
      
      
              <!-- Artefactos a Abastecer -->
              <div>
                  <div class="section-title">Conceptos a facturar:</div>
                  ${!!factibilidad.motivocli1 ? (
            `
                                  <ul>
                                  ${factibilidad.motivocli1
                ? `<li><b style="color: black;">${factibilidad.motivocli1}</b>: $ ${factibilidad.cantmotivocli1} <b>(NO INCLUYE IMPUESTOS)</b></li>`
                : ""
            }
                                  </ul>`
        ) : (
            `<p>No hay conceptos para facturar.</p>`
        )
        }
      
              </div>
          </div>
      </body>
      </html>`

    return mail;
}


export function armaMailNuevaFact(cliente, domicilio, kganual, comercial) {
    const mail = `
    <p style="color: black;">
        El representante comercial: ${comercial}
        ha cargado una nueva factibilidad en el sistema. 
    </p>
    <p><b>Cliente:</b> ${cliente} </p>
    <p><b>Domicilio Entrega:</b> ${domicilio} </p>
    <p><b>Consumo Estimado:</b> ${kganual} </p>
    Actualmente, se encuentra pendiente de revisión y requiere evaluación.`

    return mail;
}



export function armaMailAprobadoTec(idfactibilidad, cliente) {
    const mail = `<b style="color: black;">La factibilidad ${idfactibilidad} ha sido aprobada técnicamente. Es necesario un previo análisis crediticio antes de registrar el cliente. </b>
        <p><b style="color: black;">Datos del cliente: </b></p>
        <ul>
        ${cliente
            ? `<li><b style="color: black;">Razón Social</b>: ${cliente.razon_social}</li>`
            : ""
        }
        </ul>`
    return mail;
}

export function armaMailDesaprobado(factid, cliente, observaciones, direccion) {
    const mail = `<b style="color: black;">Se informa que la factibilidad ${factid} ha sido <u>DESAPROBADA.</u></b>
        <p style="color: black;"><b>Cliente: </b> ${cliente.razon_social} </p>
        <p style="color: black;"><b>Domicilio de entrega: </b> ${direccion} </p>
        <p style="color: black;"><b>Observaciones: </b> ${observaciones || "No se registran observaciones."} </p>
        <p style="color: black;">No obstante, la factibilidad permanece disponible para su revisión y modificaciones adicionales en caso de ser necesarias.</p>`

    return mail;
}
